import { MultiSelectProps, MultiSelect } from "@mantine/core"
import { useGetSimpleContractApprovalStatuses } from "@/orval/gen"
import { useTranslation } from "react-i18next"

interface ContractApprovalStatusMultiSelectProps extends Omit<
  MultiSelectProps,
  "data" | "value" | "onChange"
> {
  value?: number[]
  onChange?: (value: number[]) => void
}

export function ContractApprovalStatusMultiSelect({
  value,
  onChange,
  ...props
}: ContractApprovalStatusMultiSelectProps) {
  const { data, isLoading } = useGetSimpleContractApprovalStatuses()
  const { t } = useTranslation("app_server")
  return (
    <MultiSelect
      loading={isLoading}
      label={t("Status")}
      data={data?.map((c) => ({
        label: c.name,
        value: c.contractApprovalStatusId.toString(),
      }))}
      value={value?.map(String) || []}
      onChange={(v) => onChange?.(v.map(Number))}
      {...props}
    />
  )
}
